import React from "react";
import { Dialog } from "primereact/dialog";
// import "./attachmentConfirmationStyle.scss";
import CustomeButton from "~/components/Button";
import trashIcon from "../../../../../assets/trash-icon.svg";
import FileIcon from "~/components/file-type-icon";
import { openFileInNewTab, openPreviewInNewTab } from "~/utils/fileUtils";

const getFilenameFromReference = (fileReference) => {
  if (!fileReference) return "";
  try {
    const url = new URL(fileReference);
    const pathname = url.pathname;
    const filename = pathname.substring(pathname.lastIndexOf("/") + 1);
    return decodeURIComponent(filename);
  } catch (error) {
    console.error("Error extracting filename from reference:", error);
    return "";
  }
};

const PayslipDeleteModal = ({
  showModal,
  handleCloseModal,
  handleDelete,
  isLoading = false,
  fileData,
}) => {
  return (
    <Dialog
      visible={showModal}
      onHide={handleCloseModal}
      className="delete__payslip"
    >
      <div className="delete__payslip__container">
        <img
          className="users-card-icon-img"
          src={trashIcon}
          alt="Search Icon"
        />
        <p className="delete__payslip__container--heading">
          Are you sure you want to remove this file?
        </p>
        <p className="delete__payslip__container--description">
          {fileData?.match_status === "" || fileData?.match_status === "pending"
            ? "This will remove the selected file from your draft submission.  You can re-upload it at any time before submitting all files"
            : "This will remove the selected file from your submission.  You can re-upload it at any time before marking as complete."}
        </p>
      </div>
      <div className="file__detail">
        <FileIcon filetype={"pdf"} filename={""} />
        <span className="file__detail__name">
          {fileData?.extracted_data?.matched_filename
            ? fileData?.extracted_data?.matched_filename
            : getFilenameFromReference(fileData?.file_reference)}
        </span>
        <i
          className={`pi pi-external-link cursor-pointer`}
          onClick={() =>
            openPreviewInNewTab(
              {
                objectURL: fileData?.file_reference,
              },
              fileData?.file_reference?.includes("/ess") ? "ess" : "documents",
            )
          }
        />
      </div>
      <div className="flex justify-content-center gap-2">
        <CustomeButton
          label="Cancel"
          className="cancel-btn"
          outlined
          onClick={handleCloseModal}
        />
        <CustomeButton
          label="Yes, Remove"
          loading={isLoading}
          variant="remove"
          className="proceed-btn flex flex-row-reverse"
          onClick={() => handleDelete(fileData?.id)}
        />
      </div>
    </Dialog>
  );
};

export default PayslipDeleteModal;
